module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prizeManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("活动管理 > 奖品管理\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newPrize
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回活动")])], 1), _vm._v(" "), _c('div', {
    staticClass: "prize"
  }, [_c('el-select', {
    on: {
      "change": _vm.neirong
    },
    model: {
      value: (_vm.online),
      callback: function($$v) {
        _vm.online = $$v
      },
      expression: "online"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已发布",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未发布",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.prizes
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activityName",
      "label": "所属活动",
      "align": "center",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖品图标",
      "align": "center",
      "width": "200",
      "show-overflow-tooltip": ""
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            attrs: {
              "src": _vm.row.logoUrl
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "defineText1",
      "label": "第三方奖励ID",
      "align": "center",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deployTime",
      "label": "发放时间",
      "align": "center",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "已发放数量 / 总量",
      "align": "center",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "online",
      "label": "状态",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "align": "center",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.showDetail(_vm.row.prizeId)
              }
            }
          }, [_vm._v("详情")]), _vm._v(" "), (_vm.row.online == '未发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editNew(_vm.row.prizeId)
              }
            }
          }, [_vm._v("\n                        修改")]) : _vm._e(), _vm._v(" "), (_vm.row.online == '未发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.updateStatus(_vm.row, 0)
              }
            }
          }, [_vm._v("发布\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.row.online == '已发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.updateStatus(_vm.row, 1)
              }
            }
          }, [_vm._v("\n                        撤销发布")]) : _vm._e(), _vm._v(" "), (_vm.row.online == '未发布') ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deletePrize(_vm.row)
              }
            }
          }, [_vm._v("删除\n                    ")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ca1c6c7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/activity/prizeManage.vue
// module id = 1125
// module chunks = 0